// src/components/ISOStandards.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from "./Footer";   // adjust path if needed
import whatsapp from '../images/whatsapp.png';

const ISOStandards = () => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const savedLang = localStorage.getItem('language');
    if (savedLang && ['mr', 'hi', 'en'].includes(savedLang)) {
      setLanguage(savedLang);
    }
  }, []);

  // === TRANSLATIONS ===
  const translations = {
    pageTitle: { mr: 'आयएसओ प्रमाणने', hi: 'आईएसओ प्रमाणन', en: 'ISO Certifications' },
    management: { mr: 'व्यवस्थापन प्रणाली प्रमाणने', hi: 'प्रबंधन प्रणाली प्रमाणन', en: 'Management System Certifications' },
    itRelated: { mr: 'आयटी संबंधित सेवा', hi: 'आईटी संबंधित सेवाएँ', en: 'IT Related Services' },
    productCert: { mr: 'उत्पादन प्रमाणने', hi: 'उत्पाद प्रमाणन', en: 'Product Certifications' },
    foodSafety: { mr: 'अन्न सुरक्षा प्रमाणने', hi: 'खाद्य सुरक्षा प्रमाणन', en: 'Food Safety Certifications' },
    trainings: { mr: 'प्रशिक्षण', hi: 'प्रशिक्षण', en: 'Trainings' },
    otherCert: { mr: 'इतर प्रमाणने', hi: 'अन्य प्रमाणन', en: 'Other Certifications' },
    applyNow: { mr: 'आता अर्ज करा', hi: 'अभी आवेदन करें', en: 'Apply Now' },
    knowMore: { mr: 'अधिक जाणा', hi: 'और जानें', en: 'To know more' },
  };

  const t = (key) => translations[key][language] || translations[key]['en'];

  // === CERTIFICATION DATA (with path) ===
  const certifications = {
    management: [
      { code: 'ISO 9001', name: { mr: 'गुणवत्ता व्यवस्थापन', hi: 'गुणवत्ता प्रबंधन', en: 'Quality Management' }, path: '/cert/iso9001' },
      { code: 'ISO 37001', name: { mr: 'लाच प्रतिबंधक', hi: 'भ्रष्टाचार निरोधक', en: 'Anti-Bribery' }, path: '/cert/iso37001' },
      { code: 'ISO 13485', name: { mr: 'वैद्यकीय उपकरणे', hi: 'चिकित्सा उपकरण', en: 'Medical Devices' }, path: '/cert/iso13485' },
      { code: 'ISO 14001', name: { mr: 'पर्यावरण व्यवस्थापन', hi: 'पर्यावरण प्रबंधन', en: 'Environmental Management' }, path: '/cert/iso14001' },
      { code: 'ISO 45001', name: { mr: 'आरोग्य व सुरक्षा', hi: 'स्वास्थ्य और सुरक्षा', en: 'Occupational Health & Safety' }, path: '/cert/iso45001' },
      { code: 'ISO 41001', name: { mr: 'सुविधा व्यवस्थापन', hi: 'सुविधा प्रबंधन', en: 'Facility Management' }, path: '/cert/iso41001' },
      { code: 'ISO 22301', name: { mr: 'व्यवसाय सातत्य', hi: 'व्यवसाय निरंतरता', en: 'Business Continuity' }, path: '/cert/iso22301' },
      { code: 'ISO 21001', name: { mr: 'शिक्षण संस्था', hi: 'शैक्षणिक संस्थान', en: 'Educational Organizations' }, path: '/cert/iso21001' },
      { code: 'ISO 50001', name: { mr: 'ऊर्जा व्यवस्थापन', hi: 'ऊर्जा प्रबंधन', en: 'Energy Management' }, path: '/cert/iso50001' },
      { code: 'ISO 27001', name: { mr: 'माहिती सुरक्षा', hi: 'सूचना सुरक्षा', en: 'Information Security' }, path: '/cert/iso27001' },
      { code: 'IATF 16949', name: { mr: 'ऑटोमोटिव्ह', hi: 'ऑटोमोटिव', en: 'Automotive' }, path: '/cert/iatf16949' },
      { code: 'ISO 22000', name: { mr: 'अन्न सुरक्षा', hi: 'खाद्य सुरक्षा', en: 'Food Safety' }, path: '/cert/iso22000' },
      { code: 'ISO/IEC 20000-1', name: { mr: 'आयटी सेवा', hi: 'आईटी सेवा', en: 'IT Service' }, path: '/cert/iso20000' },
      { code: 'ISO/IEC 42001:2023', name: { mr: 'कृत्रिम बुद्धिमत्ता', hi: 'कृत्रिम बुद्धिमत्ता', en: 'Artificial Intelligence' }, path: '/cert/iso42001' },
    ],
    itRelated: [
      { code: 'CMMI', name: { mr: 'सीएमएमआय', hi: 'सीएमएमआई', en: 'CMMI' }, path: '/cert/cmmi' },
      { code: 'VAPT', name: { mr: 'व्हीएपीटी', hi: 'वीएपीटी', en: 'VAPT' }, path: '/cert/vapt' },
      { code: 'SOC', name: { mr: 'एसओसी', hi: 'एसओसी', en: 'SOC' }, path: '/cert/soc' },
      { code: 'GDPR', name: { mr: 'जीडीपीआर', hi: 'जीडीपीआर', en: 'GDPR' }, path: '/cert/gdpr' },
      { code: 'HIPAA', name: { mr: 'हिपा', hi: 'हिपा', en: 'HIPAA' }, path: '/cert/hipaa' },
      { code: 'HITRUST', name: { mr: 'हायट्रस्ट', hi: 'हायट्रस्ट', en: 'HITRUST' }, path: '/cert/hitrust' },
      { code: 'Artificial Intelligence', name: { mr: 'कृत्रिम बुद्धिमत्ता', hi: 'कृत्रिम बुद्धिमत्ता', en: 'Artificial Intelligence' }, path: '/cert/ai' },
      { code: 'PCI DSS Compliance', name: { mr: 'पीसीआय डीएसएस', hi: 'पीसीआई डीएसएस', en: 'PCI DSS Compliance' }, path: '/cert/pcidss' },
    ],
    productCert: [
      { code: 'CE Marking', name: { mr: 'सीई मार्किंग', hi: 'सीई मार्किंग', en: 'CE Marking' }, path: '/cert/ce' },
      { code: 'FCC', name: { mr: 'एफसीसी', hi: 'एफसीसी', en: 'FCC' }, path: '/cert/fcc' },
      { code: 'RoHS', name: { mr: 'रोएचएस', hi: 'रोएचएस', en: 'RoHS' }, path: '/cert/rohs' },
      { code: 'ISO 8124', name: { mr: 'आयएसओ ८१२४', hi: 'आईएसओ ८१२४', en: 'ISO 8124' }, path: '/cert/iso8124' },
    ],
    foodSafety: [
      { code: 'Halal', name: { mr: 'हलाल', hi: 'हलाल', en: 'Halal' }, path: '/cert/halal' },
      { code: 'Kosher', name: { mr: 'कोशर', hi: 'कोशर', en: 'Kosher' }, path: '/cert/kosher' },
      { code: 'ISO 22000', name: { mr: 'आयएसओ २२०००', hi: 'आईएसओ २२०००', en: 'ISO 22000' }, path: '/cert/iso22000' },
    ],
    trainings: [
      { code: 'Lead Auditor', name: { mr: 'लीड ऑडिटर', hi: 'लीड ऑडिटर', en: 'Lead Auditor' }, path: '/training/lead-auditor' },
      { code: 'Internal Auditor', name: { mr: 'अंतर्गत ऑडिटर', hi: 'आंतरिक ऑडिटर', en: 'Internal Auditor' }, path: '/training/internal-auditor' },
      { code: 'ISO Awareness', name: { mr: 'आयएसओ जागरूकता', hi: 'आईएसओ जागरूकता', en: 'ISO Awareness' }, path: '/training/awareness' },
    ],
    social: [
      { code: 'ISO 26000', name: { mr: 'आयएसओ २६०००', hi: 'आईएसओ २६०००', en: 'ISO 26000' }, path: '/cert/iso26000' },
      { code: 'ISO 22301', name: { mr: 'आयएसओ २२३०१', hi: 'आईएसओ २२३०१', en: 'ISO 22301' }, path: '/cert/iso22301' },
    ],
    otherCert: [
      { code: 'Energy Audit', name: { mr: 'ऊर्जा ऑडिट', hi: 'ऊर्जा ऑडिट', en: 'Energy Audit' }, path: '/audit/energy' },
      { code: 'Safety Audits', name: { mr: 'सुरक्षा ऑडिट', hi: 'सुरक्षा ऑडिट', en: 'Safety Audits' }, path: '/audit/safety' },
      { code: 'GMP', name: { mr: 'जीएमपी', hi: 'जीएमपी', en: 'GMP' }, path: '/cert/gmp' },
      { code: 'Environmental Audits', name: { mr: 'पर्यावरण ऑडिट', hi: 'पर्यावरण ऑडिट', en: 'Environmental Audits' }, path: '/audit/environmental' },
      { code: 'Cosmetics GMP', name: { mr: 'कॉस्मेटिक्स जीएमपी', hi: 'कॉस्मेटिक्स जीएमपी', en: 'Cosmetics GMP' }, path: '/cert/gmp-cosmetics' },
    ],
  };

  // === STYLES ===
  const styles = {
    container: { fontFamily: "'Poppins', sans-serif", backgroundColor: '#fff', color: '#333', minHeight: '100vh', margin: 0, padding: 0 },
    hero: { height: '50vh', background: 'linear-gradient(rgba(10,29,86,0.9), rgba(10,29,86,0.9)), url("https://source.unsplash.com/random/1600x900/?certification,iso")', backgroundSize: 'cover', backgroundPosition: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', color: '#fff' },
    heroTitle: { fontSize: '3.2rem', fontWeight: '700', textShadow: '0 4px 12px rgba(0,0,0,0.5)' },
    section: { padding: '4rem 2rem', maxWidth: '1400px', margin: '0 auto' },
    sectionTitle: { textAlign: 'center', fontSize: '2rem', color: '#0A1D56', marginBottom: '1.5rem', position: 'relative', paddingBottom: '0.8rem' },
    sectionTitleAfter: { content: '""', position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '80px', height: '4px', backgroundColor: '#FF7F50', borderRadius: '2px' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.8rem', marginTop: '1rem' },
    card: { backgroundColor: '#fff', padding: '1.8rem 1.4rem', borderRadius: '16px', boxShadow: '0 6px 18px rgba(0,0,0,0.08)', textAlign: 'center', transition: 'all 0.4s ease', border: '1px solid #eef2f7', position: 'relative', overflow: 'hidden' },
    cardHover: { transform: 'translateY(-10px)', boxShadow: '0 18px 35px rgba(0,0,0,0.15)', borderColor: '#0A1D56' },
    cardCode: { fontSize: '1.1rem', fontWeight: '700', color: '#0A1D56', marginBottom: '0.4rem' },
    cardName: { fontSize: '0.9rem', color: '#555', marginBottom: '0.8rem', lineHeight: '1.4' },
    knowMore: { fontSize: '0.82rem', color: '#888', marginBottom: '0.8rem', display: 'block' },
    applyBtn: { backgroundColor: '#0A1D56', color: '#fff', padding: '0.7rem 1.4rem', borderRadius: '50px', fontSize: '0.88rem', fontWeight: '600', textDecoration: 'none', display: 'inline-block', transition: 'all 0.3s ease', boxShadow: '0 4px 12px rgba(10,29,86,0.3)' },
    applyBtnHover: { backgroundColor: '#FF7F50', transform: 'translateY(-2px)', boxShadow: '0 8px 20px rgba(255,127,80,0.4)' },
    whatsappBtn: { position: 'fixed', bottom: '1.5rem', left: '1.5rem', backgroundColor: '#25D366', padding: '1rem', borderRadius: '50%', boxShadow: '0 8px 25px rgba(37,211,102,0.4)', zIndex: 1000, animation: 'float 3s ease-in-out infinite' },
    whatsappImg: { width: '36px', filter: 'brightness(0) invert(1)' },
  };

  return (
    <div style={styles.container}>
      {/* Hero */}
      <section style={styles.hero}>
        <h1 style={styles.heroTitle}>{t('pageTitle')}</h1>
      </section>

      {/* Render All Sections */}
      {Object.entries(certifications).map(([key, items]) => (
        <section key={key} style={{ ...styles.section, backgroundColor: key === 'itRelated' || key === 'foodSafety' ? '#f8f9fa' : key === 'social' ? '#f0f4f8' : '#fff' }}>
          <h2 style={styles.sectionTitle}>
            {t(key === 'social' ? 'otherCert' : key)}
            <div style={styles.sectionTitleAfter}></div>
          </h2>
          <div style={styles.grid}>
            {items.map((item, i) => (
              <div
                key={i}
                style={styles.card}
                onMouseEnter={(e) => Object.assign(e.currentTarget.style, styles.cardHover)}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = '';
                  e.currentTarget.style.boxShadow = '';
                  e.currentTarget.style.borderColor = '#eef2f7';
                }}
              >
                <div style={styles.cardCode}>{item.code}</div>
                <div style={styles.cardName}>{item.name[language]}</div>
                <span style={styles.knowMore}>{t('knowMore')}</span>
                <Link
                  to={item.path} // डायनॅमिक पाथ!
                  style={styles.applyBtn}
                  onMouseEnter={(e) => Object.assign(e.currentTarget.style, styles.applyBtnHover)}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#0A1D56';
                    e.currentTarget.style.transform = '';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(10,29,86,0.3)';
                  }}
                >
                  {t('applyNow')}
                </Link>
              </div>
            ))}
          </div>
        </section>
      ))}

      {/* WhatsApp */}
      <a href="https://wa.me/919975977462" target="_blank" rel="noopener noreferrer" style={styles.whatsappBtn}>
        <img src={whatsapp} alt="WhatsApp" style={styles.whatsappImg} />
      </a>

      {/* ✅ FOOTER HERE */}
      <footer className="footer">
  <div className="footer-grid">

    <div className="footer-col">
      <h4>Global Certification</h4>
      <p>
        15A, Navjivan Colony, Wardha Road,<br />
        Narendra Nagar, Nagpur - 440015
      </p>
    </div>

    <div className="footer-col">
      <h4>Quick Links</h4>
      <Link to="/about-us" className="f-link">About Us</Link>
      <Link to="/services-iso-standards" className="f-link">Services</Link>
      <Link to="/gallery" className="f-link">Gallery</Link>
      <Link to="/contact-us" className="f-link">Contact Us</Link>
    </div>

    <div className="footer-col">
      <h4>Follow Us</h4>
      <p>Facebook | LinkedIn | YouTube</p>
    </div>

  </div>

  <div className="copyright">
    © {new Date().getFullYear()} Global Certification. All Rights Reserved.
  </div>
</footer>
      
<style jsx>
{`
/* ==================== FOOTER (SHORTER BOXES) ==================== */
.footer {
  background: linear-gradient(135deg, #0A1D56, #0f2a5e);
  color: #ddd;
  padding: 3rem 2rem 1.5rem;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto 1.5rem;
}

.footer-col {
  min-height: auto;
}

.footer h4 {
  color: #fff;
  margin-bottom: 0.8rem;
  font-size: 1.05rem;
  padding-bottom: 0.4rem;
}

.footer h4::after {
  width: 35px;
  height: 2.5px;
}

.f-link {
  display: block;
  margin-bottom: 0.45rem;
  font-size: 0.92rem;
  color: #ccc;
}

.copyright {
  font-size: 0.88rem;
  padding-top: 1.2rem;
}
`}
</style>
    </div>
  );
};

export default ISOStandards;